export const nav = {
  home: 'Home',
  services: 'Services',
  solutions: 'Solutions',
  tools: 'Tools',
  about: 'About Us',
  contact: 'Contact',
  requestQuote: 'Request Quote'
};

export const hero = {
  title1: 'Global Ocean',
  title2: 'Transportation',
  title3: 'Solutions',
  description: 'Delivering excellence in ocean freight services with cutting-edge technology and unmatched expertise. We connect your business to the world through reliable, efficient, and sustainable maritime solutions.',
  exploreServices: 'Explore Services',
  getStarted: 'Get Started',
  vessels: 'Vessels',
  countries: 'Countries',
  support: 'Support'
};

export const services = {
  title: 'Our Services',
  subtitle: 'Comprehensive maritime services designed to enhance your business relationships and logistics efficiency',
  consulting: {
    title: 'Consulting Services',
    description: 'Expert maritime consulting to optimize your shipping operations and supply chain strategies'
  },
  portTour: {
    title: 'Port Tour Services',
    description: 'Comprehensive guided tours of Los Angeles Port and Long Beach Port container terminals'
  },
  seminar: {
    title: 'Industry Seminars',
    description: 'Educational seminars covering latest trends, regulations, and best practices in ocean transportation'
  },
  logisticsInfo: {
    title: 'Logistics Information Hub',
    description: 'Access to valuable real-time logistics data, market insights, and industry intelligence'
  },
  routing: {
    title: 'Transportation Routing',
    description: 'Introduction to reliable and efficient transportation routes optimized for your cargo needs'
  },
  solutions: {
    title: 'Logistics Solutions',
    description: 'Innovative solutions to enhance efficiency and reduce costs in your logistics operations'
  },
  relationship: {
    title: 'Customer Relationship Building',
    description: 'Facilitating connections and partnerships between customers to strengthen business networks'
  }
};

export const solutionsSection = {
  tag: 'CONSULTING',
  title1: 'Tailored Solutions',
  title2: 'For Your Business',
  title3: 'Challenges',
  description: 'Our expert consultants work closely with you to understand your unique requirements and develop customized solutions that drive efficiency, reduce costs, and enhance your competitive advantage in the global marketplace.',
  scheduleConsultation: 'Schedule Consultation',
  learnMore: 'Learn More',
  visibility: {
    title: 'Supply Chain Visibility',
    description: 'Real-time tracking and monitoring of your cargo across the entire supply chain',
    feature1: 'Live GPS tracking',
    feature2: 'Automated alerts',
    feature3: 'Historical data'
  },
  costOptimization: {
    title: 'Cost Optimization',
    description: 'Reduce shipping costs through intelligent route planning and consolidation',
    feature1: 'Rate comparison',
    feature2: 'Volume discounts',
    feature3: 'Cost analytics'
  },
  riskManagement: {
    title: 'Risk Management',
    description: 'Comprehensive insurance and risk mitigation strategies for your shipments',
    feature1: 'Cargo insurance',
    feature2: 'Compliance monitoring',
    feature3: 'Risk assessment'
  }
};

export const tools = {
  title: 'Powerful Tools',
  subtitle: 'Advanced technology solutions to streamline your shipping operations',
  containerTracking: {
    name: 'Container Tracking System',
    description: 'Track your containers in real-time across all major shipping lines'
  },
  rateCalculator: {
    name: 'Rate Calculator',
    description: 'Get instant quotes for your shipping needs with our advanced calculator'
  },
  documentation: {
    name: 'Documentation Portal',
    description: 'Manage all your shipping documents in one secure digital platform'
  },
  analytics: {
    name: 'Analytics Dashboard',
    description: 'Visualize your shipping data with powerful analytics and insights'
  },
  tryNow: 'Try it now',
  requestDemo: 'Request Demo Access'
};

export const about = {
  title: 'About SHIPFAN',
  description1: 'With over 20 years of experience in ocean transportation, SHIPFAN has built a reputation for reliability, innovation, and customer-centric service. Our team of maritime experts combines deep industry knowledge with cutting-edge technology to deliver solutions that exceed expectations.',
  description2: 'In partnership with Japan\'s maritime information newspaper "Japan Maritime Daily," we regularly publish monthly articles titled "Los Angeles Report" covering U.S. logistics information, market trends, and various industry events.',
  mission: 'Our Mission',
  missionText: 'To revolutionize ocean transportation through innovation, sustainability, and unwavering commitment to customer success.'
};

export const contact = {
  title: 'Get In Touch',
  description: 'Ready to optimize your ocean transportation? Contact the SHIPFAN team of experts today and discover how we can help your business thrive.',
  email: 'Email',
  phone: 'Phone',
  office: 'Office',
  form: {
    fullName: 'Full Name',
    fullNamePlaceholder: 'John Doe',
    emailAddress: 'Email Address',
    emailPlaceholder: 'john@example.com',
    company: 'Company',
    companyPlaceholder: 'Your Company',
    serviceInterest: 'Service Interest',
    selectService: 'Select a service',
    message: 'Message',
    messagePlaceholder: 'Tell us about your shipping needs...',
    maxCharacters: 'Maximum 500 characters',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    successMessage: 'Thank you! Your message has been sent successfully. We\'ll get back to you soon.',
    errorMessage: 'Sorry, there was an error sending your message. Please try again.'
  }
};

export const footer = {
  tagline: 'Connecting the world through reliable ocean transportation solutions',
  services: 'Services',
  solutions: 'Solutions',
  company: 'Company',
  resources: 'Resources',
  careers: 'Careers',
  news: 'News',
  documentation: 'Documentation',
  support: 'Support',
  faq: 'FAQ',
  copyright: '© 2024 SHIPFAN. All rights reserved.',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  websiteBuilder: 'Website Builder'
};
